import { extend as _rawExtend, override as _rawOverride } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import Button from 'flarum/common/components/Button';
import adminPanelModal from './modal/adminPanelModal';
export default function modifyHeaderSecondary() {
  // (辉哥 9/17 16:47 派 Coder 修): webpack DCE 把 const helper globals 去掉,
  // 改用 function declaration 让 helper 名字在函数体内可用
  function safeExtend(targetOrClass, method, fn) {
    if (!window.__zivenCoreSafeExtend) {
      console.warn('[ziven-core] safeExtend helper not loaded, skipped:', method);
      return null;
    }
    return window.__zivenCoreSafeExtend(targetOrClass, method, fn);
  }
  function safeOverride(targetOrClass, method, fn) {
    if (!window.__zivenCoreSafeOverride) {
      console.warn('[ziven-core] safeOverride helper not loaded, skipped:', method);
      return null;
    }
    return window.__zivenCoreSafeOverride(targetOrClass, method, fn);
  }
  safeExtend(HeaderSecondary, 'items', function (items) {
    // (辉哥 10/21 派修): 「管理后台」入口必须同时判管理员。
    // ① 只判登录的话, 任何普通会员顶栏都会挂上扳手按钮, 点开 adminPanelModal
    //    里的 iframe (/admin?_iframe=...) 会打到 ziven-core 的
    //    RestrictAdminAccess 中间件 -> assertAdmin() -> 非管理员直接 403 权限页。
    // ② 判据用 Flarum 官方的 app.forum.attribute('adminUrl'):
    //    ForumResource 里 adminUrl 只在 $actor->can('administrate') 时下发,
    //    非管理员根本拿不到这个属性, 所以它本身就是「是不是管理员」的判据
    //    (flarum 核心 SessionDropdown.tsx 也是用它来加管理员入口的)。
    if (!app.session.user || !app.forum.attribute('adminUrl')) return;
    items.add('settingIcon', m(Button, {
      className: "Button Button--flat",
      onclick: () => {
        app.modal.show(adminPanelModal);
      },
      icon: "fas fa-wrench"
    }, app.translator.trans('core.forum.header.admin_button')), 15);
  });
}